import { Pipe, PipeTransform } from '@angular/core';
import { ProductVariant } from '../../../models/ProductVariant';

@Pipe({
	name: 'productVariants'
})
export class ProductVariantsPipe implements PipeTransform {

	transform(variants:ProductVariant[] ): string {
		let aStock = 0;
		let cVariantsWithoutStock = 0;
		for (let f = 0; f < variants.length; f++) {
			aStock += variants[f].stock;
			if (variants[f].stock == 0) {
				cVariantsWithoutStock++;
			}
		}
		if (aStock <= 0)
			return "Sin stock";

		let s = aStock +" en stock";
		if (cVariantsWithoutStock) {
			s += ". "+ cVariantsWithoutStock +" "+ (cVariantsWithoutStock==1 ? "variante" : "variantes") +" sin stock";
		}
		return s;
	}

}
